<script setup lang="ts">
  import type { RouteLocationRaw } from 'vue-router';
  import CheckMarkIcon from '@/shared/assets/icons/CheckMarkIcon.svg';
  import { ColoredButton } from '@/shared/ui';

  defineProps<{
    cancelRoute: RouteLocationRaw;
    disabled: boolean;
    loading?: boolean;
  }>();

  const emit = defineEmits<{
    (e: 'save'): void;
  }>();

  const handleSave = () => {
    emit('save');
  };
</script>

<template>
  <div class="flex justify-end gap-6 pr-4 pb-1.5 mt-8">
    <router-link
      :to="cancelRoute"
      class="text-gray-03 border border-gray-03 rounded-lg px-4 py-3 text-sm font-medium"
    >
      Cancelar
    </router-link>
    <ColoredButton
      text="Salvar"
      :icon="CheckMarkIcon"
      icon-alt="Icone de check"
      :disabled="disabled"
      :loading="loading"
      @click="handleSave"
    />
  </div>
</template>
